import React from 'react';
import { ServicesSolutions } from '../components/ServicesSolutions';
export function ServicesPage() {
  return <main data-id="element-346">
      <ServicesSolutions data-id="element-347" />
    </main>;
}